// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const commonEnums = {
  examStatus: {
    draft: "草稿",
    published: "已发布",
    running: "进行中",
    ended: "已结束",
    archived: "已归档",
  },
  environmentInstanceStatus: {
    provisioning: "创建中",
    ready: "就绪",
    running: "运行中",
    evaluated: "已评测",
    destroyed: "已销毁",
    failed: "失败",
    expired: "已过期",
  },
  questionStatus: {
    draft: "草稿",
    published: "已发布",
    archived: "已归档",
  },
  paperStatus: {
    draft: "草稿",
    published: "已发布",
    archived: "已归档",
  },
  difficulty: {
    easy: "简单",
    medium: "中等",
    hard: "困难",
  },
  paperType: {
    fixed_manual: "固定卷-手工",
    fixed_rule: "固定卷-规则",
    differentiated: "差异卷",
    variant: "变体卷",
    adaptive: "自适应卷",
  },
  judgeVerdict: {
    accepted: "正确",
    wrong_answer: "错误",
    compile_error: "编译错误",
    pending: "等待中",
    runtime_error: "运行错误",
    time_limit_exceeded: "超时",
  },
  resultVisibility: {
    hidden: "不展示成绩",
    after_submit: "交卷后可见",
    after_publish: "发布后可见",
  },
  answerVisibility: {
    hidden: "不展示答案",
    analysis_only: "仅展示解析",
    full: "展示答案与解析",
  },
  publishScoreMode: {
    immediate: "即时发布",
    manual: "人工发布",
  },
  scoreRecordSource: {
    auto: "自动评分",
    environment: "环境评分",
    judge: "判题评分",
    ai: "AI 评分",
    manual: "人工评分",
    review: "复核评分",
  },
  scoreRecordStatus: {
    valid: "生效",
    invalid: "无效",
    pending: "待生效",
  },
  scoreRecordComments: {
    autoObjectiveScoring: "系统自动客观题评分",
    manualReview: "人工复核评分",
    flagValidationPassed: "Flag 校验通过",
    flagValidationFailed: "Flag 校验失败",
    flagValidatedDeferred: "交卷时 Flag 延迟校验通过",
    flagValidationFailedDeferred: "交卷时 Flag 延迟校验失败",
    noFlagSubmitted: "未提交 Flag",
    attackDefenseFlagSnapshotMissing: "攻防 Flag 快照缺失",
    judgeResult: "判题结果",
  },
  questionType: {
    single_choice: "单选题",
    multiple_choice: "多选题",
    judgment: "判断题",
    short_answer: "简答题",
    code: "编程题",
    practical: "实操题",
    attack_defense: "夺旗题",
  },
  questionTypeShort: {
    single_choice: "单选",
    multiple_choice: "多选",
    judgment: "判断",
    short_answer: "简答",
    code: "编程",
    practical: "实操",
    attack_defense: "夺旗",
    mixed: "综合",
  },
  attemptStatus: {
    assigned: "待作答",
    contract_missing: "状态缺失",
    not_started: "未开始",
    started: "作答中",
    submitted: "已交卷",
    graded: "已评分",
    expired: "已过期",
    absent: "缺考",
    cancelled: "已取消",
    in_progress: "作答中",
    abandoned: "已放弃",
  },
  reviewStatus: {
    pending: "待阅卷",
    completed: "已完成",
  },
  userStatus: {
    active: "启用",
    inactive: "停用",
    locked: "已锁定",
    disabled: "禁用",
  },
} as const;
